import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const APIBaseURL = 'https://palmetto-wab.s3.amazonaws.com/s3db/groups.json';

export const palmettoGroupApi = createApi({
  reducerPath: 'palmettoGroupApi',
  baseQuery: fetchBaseQuery({ baseUrl: APIBaseURL }),
  endpoints: (builder) => ({
    getPalmettoGroups: builder.query<PalmettoGroups[], undefined>({
      query: () => ({
        url: '',
      }),
    }),
  }),
});

export const { useLazyGetPalmettoGroupsQuery } = palmettoGroupApi;
